import type { SortingChapter } from "../sorting/chapters.ts";

/** The ten Fun Arcade chapters (10 levels each); same shape as the Sorting chapters. */
export type ArcadeChapter = SortingChapter;

const chapter = (n: number, themeId: string, name: string, focus: string, palette: readonly [string, string]): ArcadeChapter => ({
  chapter: n,
  themeId,
  name,
  focus,
  firstLevel: (n - 1) * 10 + 1,
  lastLevel: n * 10,
  palette,
});

/** Every chapter adds exactly one idea (docs/FUN_ARCADE.md §2). Only the prototype level is playable for now. */
export const ARCADE_CHAPTERS: readonly ArcadeChapter[] = [
  chapter(1, "slip", "Cẩu tuột tay", "Kéo thú về lỗ từng chặng, rơi trúng là hất văng", ["#ffe9f2", "#fff3dc"]),
  chapter(2, "grips", "Lượt chắc tay", "Cẩu yếu cẩu chắc thay phiên nhau", ["#e9f0ff", "#ffeaf3"]),
  chapter(3, "tall", "Chồng cao", "Chồng đầy thì thú bị hất lăn tiếp", ["#fff4d9", "#ffe6ea"]),
  chapter(4, "heavy", "Thú nặng ký", "Thú bự cẩu kéo ít hơn một cột", ["#e7f7ef", "#f0e9ff"]),
  chapter(5, "ribbon", "Dây ruy băng", "Hai bạn buộc nơ được gắp cùng nhau", ["#ffeef0", "#fff6df"]),
  chapter(6, "glass", "Vách kính", "Vách kính chặn đường, cẩu tuột tay ngay trước vách", ["#e3f4ff", "#ffedf6"]),
  chapter(7, "bouncy", "Bóng nảy", "Bóng rơi xuống còn nảy thêm một cột", ["#fff0e0", "#e9f1ff"]),
  chapter(8, "heavy-ribbon", "Nặng và nơ", "Thú nặng gặp dây ruy băng", ["#efe7ff", "#ffefe0"]),
  chapter(9, "glass-bouncy", "Kính và bóng", "Vách kính gặp bóng nảy", ["#e2f6f6", "#ffe9f1"]),
  chapter(10, "grand", "Máy siêu cấp", "Mọi bí kíp trong chiếc máy to nhất hội chợ", ["#fff0f7", "#e8e7ff"]),
];

export function arcadeChapterOfLevel(levelId: number): ArcadeChapter {
  const found = ARCADE_CHAPTERS[Math.floor((levelId - 1) / 10)];
  if (!found) throw new RangeError(`no chapter for level ${levelId}`);
  return found;
}
